import { Photo } from "./photo";

export const PhotoList:Photo[] = [
    {
        imageUrl: "etiGumusMiniSlider-1.jpg", imageName: "Eti Gumus", imageOrder: 1
    },
    {
        imageUrl: "etiGumusMiniSlider-2.jpg", imageName: "Eti Gumus", imageOrder: 1
    },
    {
        imageUrl: "etiGumusMiniSlider-3.jpg", imageName: "Eti Gumus", imageOrder: 1
    },
]


// WEBPACK FOOTER //
// /Users/emrevolkanucar/Desktop/Angular/etigumus/src/app/home/evuslider/photo-list.mock.ts